import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalVariant, useModal } from 'cat-ecommerce-alloy';
import { v4 } from 'uuid';
import { useSystemFeedback } from '@app/hooks';
import { setConflictResolutionFlag } from '@app/store/account/actions';
import { ERROR_DOMAIN, ERROR_PATH } from '@app/constants/errorConstants';
import ExceptionFeedbackBySelector from '@app/components/common/Exception/ExceptionFeedbackBySelector';
import useConflictNotes from '../../hooks/useConflictNotes';
import { getConflictInitialValue } from '../../../utils';
import ResolutionForm from '../../../ResolutionForm';
import InfoText from '../../../InfoText';

const ResolutionModal = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const { clearError } = useSystemFeedback();
  const conflictResolutionModalProps = useModal();
  const { getPartList } = useConflictNotes();
  const isOpenConflictResolution = useSelector(
    state => state.account?.isOpenConflictResolution
  );
  const initialValues = getConflictInitialValue(getPartList);
  const errorSelector = state =>
    state.errors[ERROR_DOMAIN.CONFLICT_MODAL]?.[
      ERROR_PATH.CONFLICT_RESOLUTION_MODAL
    ];
  const onModalClose = () => {
    const errorDomain = ERROR_DOMAIN.CONFLICT_MODAL;
    const errorPath = ERROR_PATH.CONFLICT_RESOLUTION_MODAL;
    dispatch(clearError(errorDomain, errorPath));
    dispatch(setConflictResolutionFlag(false));
    conflictResolutionModalProps.close();
  };
  const resolutionTexts = [
    {
      title: t('CHOOSE_AND_EDIT_NOTES'),
      className:
        'u-fs--16 u-color--ExtraDarkGray text-uppercase text-univers--bold fw-bold pb-3',
      id: 1
    },
    {
      title: t('SELECT_EDIT_OLD_NEW_NOTES'),
      className: 'u-color--DarkGray u-fs--14 pb-3',
      id: 2
    }
  ];
  useEffect(() => {
    if (isOpenConflictResolution) {
      conflictResolutionModalProps.open();
    }
  }, [isOpenConflictResolution, conflictResolutionModalProps.open]);

  return (
    <div className="container">
      <Modal
        close={onModalClose}
        contentClassName={'pb-0 pe-0'}
        isOpen={conflictResolutionModalProps.isOpen}
        title={t('CONFLICTING_NOTES_MODAL')}
        variant={ModalVariant.large}
      >
        <ExceptionFeedbackBySelector
          selector={errorSelector}
          className="mb-2 me-2"
        />
        <InfoText data={resolutionTexts} />
        <ResolutionForm
          key={v4()}
          initialValues={initialValues}
          partList={getPartList}
          onModalClose={onModalClose}
          {...conflictResolutionModalProps}
        />
      </Modal>
    </div>
  );
};

export default ResolutionModal;
